import { render } from "./PaymentMethodsList.vue?vue&type=template&id=3fbd6a65&ts=true"
import script from "./PaymentMethodsList.vue?vue&type=script&lang=ts"
export * from "./PaymentMethodsList.vue?vue&type=script&lang=ts"

import "./PaymentMethodsList.vue?vue&type=style&index=0&id=3fbd6a65&lang=css"

import exportComponent from "D:\\YellowBeardProject\\Hermelin\\hermelinshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__